import { CUSTOM_ELEMENTS_SCHEMA, NgModule, importProvidersFrom } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CustomFormComponent } from './components/custom-form/custom-form.component';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { FileUploadComponent } from './components/form-components/file-upload/file-upload.component';
import { FileUploadModule } from 'ng2-file-upload';
import { SlotSelectionComponent } from './components/slot-selection/slot-selection.component';
import { AppMaterialModule } from './app-material-module';
import { LoginComponent } from './components/login/login.component';
import { LoginPageComponent } from './pages/login-page/login-page.component';
import { RegisterComponent } from './components/register/register.component';
import { OtpComponent } from './components/otp/otp.component';
import { PageNotFoundComponent } from './pages/page-not-found/page-not-found.component';
import { DatePipe, CommonModule, AsyncPipe  } from '@angular/common';


import { FooterComponent } from './components/footer/footer.component';
import { DashboardComponent } from './pages/dashboard/dashboard.component';
import { NavbarComponent } from './components/navbar/navbar.component';
import { AppointmentComponent } from './components/appointment/appointment.component';
import { BookingDetailsComponent } from './pages/booking-details/booking-details.component';
import { ButtonDirective } from './directives/button.directive';
import { LoadingButtonDirective } from './directives/loadingButton.directive';
import { GeneralInstructionsComponent } from './components/general-instructions/general-instructions.component';
import { BookingComponent } from './pages/booking/booking.component';
import { RefundPolicyComponent } from './pages/refund-policy/refund-policy.component';
import { PrivacyPolicyComponent } from './pages/privacy-policy/privacy-policy.component';
import { TermsConditionsComponent } from './pages/terms-conditions/terms-conditions.component';
import { TrackAppointmentComponent } from './pages/track-appointment/track-appointment.component';
import { BookingDetailsOverviewComponent } from './components/booking-details-overview/booking-details-overview.component';
import { FooterMenuComponent } from './components/footer-menu/footer-menu.component';
import { AuthInterceptorService } from './services/auth-interceptor.service';
import { BookingSummaryComponent } from './components/booking-summary/booking-summary.component';
import { BookingStatusComponent } from './pages/booking-status/booking-status.component';
import { FormComponent } from './pages/form/form.component';
import { SlotSelectionRescheduleComponent } from './components/slot-selection-reschedule/slot-selection-reschedule.component';
import { RescheduleAppointmentComponent } from './pages/reschedule-appointment/reschedule-appointment.component';
import { LoaderComponent } from './components/loader/loader.component';
import { NgxSpinnerModule } from 'ngx-spinner';
import { EditFormComponent } from './pages/edit-form/edit-form.component';
import { OfflineBookingComponent } from './pages/offline-booking/offline-booking.component';
import { FormSuccessComponent } from './pages/form-success/form-success.component';
import { SpecialtiesComponent } from './pages/specialties/specialties.component';
import { DoctorsListComponent } from './pages/doctors-list/doctors-list.component';
import { SignUpComponent } from './pages/sign-up/sign-up.component';

import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';

import { register } from 'swiper/element/bundle';
import { BookingListComponent } from './pages/booking-list/booking-list.component';
import { DoctorsComponent } from './pages/doctors/doctors.component';
import { ProfileComponent } from './pages/profile/profile.component';
import { UpdateProfileComponent } from './components/update-profile/update-profile.component';
import { HomeComponent } from './pages/home/home.component';
import { BranchesComponent } from './pages/branches/branches.component';
import { AboutComponent } from './pages/about/about.component';
import { ContactComponent } from './pages/contact/contact.component';
import { FaqComponent } from './pages/faq/faq.component';
import { MessageComponent } from './components/message/message.component';
import { AiBookingComponent } from './pages/ai-booking/ai-booking.component';
import { ChatWidgetComponent } from './components/chat-widget/chat-widget.component';

register();




@NgModule({ schemas: [CUSTOM_ELEMENTS_SCHEMA],
    declarations: [
        AppComponent,
        CustomFormComponent,
        FileUploadComponent,
        SlotSelectionComponent,
        LoginComponent,
        LoginPageComponent,
        RegisterComponent,
        OtpComponent,
        PageNotFoundComponent,
        FooterComponent,
        DashboardComponent,
        NavbarComponent,
        AppointmentComponent,
        BookingDetailsComponent,
        ButtonDirective,
        LoadingButtonDirective,
        GeneralInstructionsComponent,
        BookingComponent,
        RefundPolicyComponent,
        PrivacyPolicyComponent,
        TermsConditionsComponent,
        TrackAppointmentComponent,
        BookingDetailsOverviewComponent,
        FooterMenuComponent,
        BookingSummaryComponent,
        BookingStatusComponent,
        FormComponent,
        SlotSelectionRescheduleComponent,
        RescheduleAppointmentComponent,
        LoaderComponent,
        EditFormComponent,
        OfflineBookingComponent,
        FormSuccessComponent,
        SpecialtiesComponent,
        DoctorsListComponent,
        BookingListComponent,
        SignUpComponent,
        DoctorsComponent,
        ProfileComponent,
        UpdateProfileComponent,
        HomeComponent,
        BranchesComponent,
        AboutComponent,
        ContactComponent,
        FaqComponent,
        MessageComponent,        
        AiBookingComponent,
        ChatWidgetComponent,
    ],
    bootstrap: [AppComponent], imports: [       
        BrowserModule,    
        AppRoutingModule,
        BrowserAnimationsModule,
        FormsModule,
        ReactiveFormsModule,
        FileUploadModule,
        AppMaterialModule,               
        NgxSpinnerModule, 
        CommonModule,
        AsyncPipe,  // Include CommonModule in imports     
        
        ], providers: [
          {provide: HTTP_INTERCEPTORS, useClass: AuthInterceptorService, multi: true },
          //Please refer: https://github.com/willmendesneto/ngx-skeleton-loader/issues/158
          importProvidersFrom(
            NgxSkeletonLoaderModule.forRoot({ animation: 'pulse' }),
          ),
           DatePipe, provideHttpClient(withInterceptorsFromDi())
          ] 
          })
export class AppModule { }
